import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PolicyService } from '../../../policy/policy.service';
import { IDocument } from '../../athora.constants';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrl: './document-upload.component.scss',
})
export class DocumentUploadComponent implements OnInit, OnDestroy {

  @Input() documents: IDocument[];
  @Input() isAlreadySubmitted: boolean;
  @Input() isHelpDeskAccount: boolean;

  maxFileSize: number = 5 * 1024 * 1024;

  destroy$ = new Subject<boolean>();

  constructor(
    private _policyService: PolicyService,
    private _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.retrieveDocuments();
  }

  retrieveDocuments(): void {
    LoggerService.logInfo(this.constructor.name, 'retrieveDocuments');
    this._policyService.retrieveDocuments();
  }

  downloadDocument(document: IDocument): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocument', { document });
    this._policyService.downloadDoc(document);
  }

  onSelectFile(document: IDocument, event: any): void {
    const input = event.target;
    if (input?.files?.length) {
      const fileToUpload = input.files[0];
      if (fileToUpload?.size > this.maxFileSize) {
        this._alertService.openErrorMessage('Attenzione! La dimensione del file è superiore a ' + (this.maxFileSize / 1024 / 1024).toString() + ' MB', 'onSelectFile');
        return;
      }
      if (fileToUpload?.type !== 'application/pdf') {
        this._alertService.openErrorMessage('Attenzione! È possibile caricare solo file in formato PDF', 'onSelectFile');
        return;
      }
      const formData = new FormData();
      formData.append("key", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.key', null));
      formData.append("Policy", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.Policy', null));
      formData.append("X-Amz-Signature", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.X-Amz-Signature', null));
      formData.append("X-Amz-Algorithm", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.X-Amz-Algorithm', null));
      formData.append("X-Amz-Credential", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.X-Amz-Credential', null));
      formData.append("X-Amz-Date", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.X-Amz-Date', null));

      const token = CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.X-Amz-Security-Token', null)
      if (token) {
        formData.append("X-Amz-Security-Token", token);
      }

      const fileName = fileToUpload?.name ?? '';
      const lastDotIndex = fileName.lastIndexOf('.');
      const rawExtension = lastDotIndex >= 0 ? fileName.slice(lastDotIndex + 1).toLowerCase() : '';
      // guard against files accepted by MIME check but lacking a .pdf extension
      const isPdfExtension = rawExtension === 'pdf';
      const fileExtension = 'pdf';
      const baseFileName = isPdfExtension ? fileName.slice(0, lastDotIndex) : fileName;

      formData.append("x-amz-meta-format", fileExtension);
      formData.append("x-amz-meta-filename", baseFileName);
      formData.append("x-amz-meta-size", fileToUpload?.size?.toString());
      formData.append("x-amz-meta-pages", "");
      formData.append("bucket", CommonUtils.checkAndGet(document, 'S3UploadUrl.fields.bucket', null));

      formData.append('file', fileToUpload);

      const headers = new HttpHeaders()
        .set('skipAuthorization', 'true');

      const url = CommonUtils.checkAndGet(document, 'S3UploadUrl.url', null);
      this._policyService.uploadDoc({
        formData: formData,
        url: url,
        headers: headers
      })
    }
  }

  get policyId(): string {
    return this._policyService.policyId;
  }

  get operationId(): string {
    return this._policyService.operationId;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
